import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import styles from './AddUser.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Navbar from './Navbar';

const AddUser = () => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    role: '',
    permissions: '',
  });
  const [roles, setRoles] = useState([]);
  const [userRole, setUserRole] = useState(null);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');

    // Fetch the user's role to determine if they are an admin
    const fetchUserRole = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_URL}/auth/userRole`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUserRole(res.data.role);

        if (res.data.role !== 'admin') {
          navigate('/unauthorized'); // Redirect if not admin
        }
      } catch (err) {
        console.error('Failed to fetch user role', err);
      }
    };

    // Fetch available roles
    const fetchRoles = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_URL}/roles`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setRoles(res.data);
      } catch (err) {
        setError('Failed to fetch roles');
        console.error(err);
      }
    };

    fetchUserRole();
    fetchRoles();
  }, [navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    try {
      await axios.post(`${process.env.REACT_APP_URL}/users`, {
        ...formData,
        permissions: formData.permissions.split(',').map((perm) => perm.trim()),
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      navigate('/dashboard');
    } catch (err) {
      setError('Failed to add user');
      console.error(err);
    }
  };

  if (userRole !== 'admin') {
    return <p>You do not have permission to add users.</p>;
  }

  return (
    <>
    <div className="App">
      <Navbar />
      <div className="allContent">
        <Container fluid>
          <Row className="justify-content-center">
            <Col xs="12" lg="7" className='mt-1'>
            <div className={styles.addUser}>
              <h2>Add User</h2>
              {error && <p className={styles.error}>{error}</p>}
              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  placeholder="Username"
                  required
                />
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email"
                  required
                />
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Password"
                  required
                />
                <select
                  name="role"
                  value={formData.role}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select a role</option>
                  {roles.map((role) => (
                    <option key={role.name} value={role.name}>{role.name}</option>
                  ))}
                </select>
                <input
                  type="text"
                  name="permissions"
                  value={formData.permissions}
                  onChange={handleChange}
                  placeholder="Permissions (comma separated)"
                />
                <button type="submit">Add User</button>
              </form>
            </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
    </>
  );
};

export default AddUser;
